import { Empty } from 'antd';
export default Empty;
